import { useState, useCallback, useEffect } from "react";
import { motion } from "framer-motion";

const PhotoGallery = () => {
  const [activeImage, setActiveImage] = useState(0);
  const [loading, setLoading] = useState(true);

  const galleryData = [
    { id: 1, title: "Image 1", imageUrl: "/studio1.jpg" },
    { id: 2, title: "Image 2", imageUrl: "/studio2.png" },
    { id: 3, title: "Image 3", imageUrl: "studio3.webp" },
    { id: 4, title: "Image 4", imageUrl: "studio4.jpg" },
    { id: 5, title: "Image 5", imageUrl: "studio1.jpg" },
    { id: 6, title: "Image 6", imageUrl: "studio3.webp" },
    { id: 7, title: "Image 7", imageUrl: "studio4.jpg" },
    { id: 8, title: "Image 8", imageUrl: "studio1.jpg" },
  ];

  const handleKeyNavigation = useCallback(
    (e) => {
      if (e.key === "ArrowUp" && activeImage > 0) {
        setActiveImage((prev) => prev - 1);
      } else if (e.key === "ArrowDown" && activeImage < galleryData.length - 1) {
        setActiveImage((prev) => prev + 1);
      }
    },
    [activeImage, galleryData.length]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyNavigation);
    return () => window.removeEventListener("keydown", handleKeyNavigation);
  }, [handleKeyNavigation]);

  const handleImageLoad = () => setLoading(false);

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8" style={{ background: "linear-gradient(to right, #000000, #434343)" }} id="StudioImg">
      <h1 className="text-6xl font-bold text-white text-center mb-6" style={{
        fontSize: "clamp(2rem, 5vw, 2.5rem)",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "2px",
        color: "#fdac00",
        marginBottom: "2rem",
      }}>
        {Array.from(" Studio Images").map((char, index) => (
          <motion.span key={index} style={{ display: "inline-block", color: "#fdac00", padding: "0 2px", cursor: "pointer" }}
            whileHover={{ y: -8 }} transition={{ type: "spring", stiffness: 300, damping: 10 }}>
            {char === " " ? "\u00A0" : char}
          </motion.span>
        ))}
      </h1>

      <div className="max-w-screen-3xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden w-full">
        <div className="flex flex-col lg:flex-row">
          {/* Left Panel (Increased Image Height) */}
          <div className="lg:w-3/5 p-4 bg-black">
            <div className="relative h-[400px] sm:h-[500px] md:h-[600px] lg:h-[750px] w-full abc">
              {loading && <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-lg" />}
              <img src={galleryData[activeImage].imageUrl} alt={`Studio ${activeImage + 1}`} className="w-full h-full object-cover rounded-lg"
                loading="lazy" onLoad={handleImageLoad} />
            </div>
          </div>

          {/* Right Panel (Includes Image Title) */}
          <div className="lg:w-2/5 bg-gray-50 p-4 custom-panel" style={{ background: "linear-gradient(to right, #000000, #434343)" }}>
  <div className="h-[calc(90vh-4rem)] lg:h-[calc(90vh-7rem)] overflow-y-auto custom-scrollbar">
    {galleryData.map((item, index) => (
      <div key={item.id} onMouseEnter={() => setActiveImage(index)}
        className={`group w-full mb-4 p-2 rounded-lg transition-all ${
          activeImage === index ? "bg-gray-600 text-white" : "hover:bg-gray-700"
        }`} aria-label={`Select Image ${index + 1}`}>
        <div className="flex gap-4 items-center">
          <div className="w-28 h-28 flex-shrink-0">
            <img src={item.imageUrl} alt={`Studio ${index + 1}`} className="w-full h-full object-cover rounded-lg" loading="lazy" />
          </div>
          <div className="flex-1 text-left">
            <h3 className={`font-medium line-clamp-2 transition-colors ${
              activeImage === index ? "text-black" : "text-white group-hover:text-black"
            }`} style={{ fontSize: "1.3rem" }}>
              {item.title}
            </h3>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>
<style>{`
  @media (max-width: 1440px) {
    .custom-panel {
      height: calc(85vh - 4rem) !important; /* Decrease height */
    }

    .custom-scrollbar {
      max-height: calc(85vh - 6rem) !important; /* Adjust scrollbar height */
      overflow-y: auto;
    }

    .abc {
      height: calc(75vh - 2rem) !important; /* Reduce image height */
    }
  }

  /* Scrollbar Customization */
  .custom-scrollbar::-webkit-scrollbar {
    width: 10px; /* Adjusted scrollbar width */
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: #222;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`}</style>



        </div>
      </div>
    </div>
  );
};

export default PhotoGallery;
